import React from "react";
import { CliBlock } from "./CliBlock";
import { CheckCircle2, AlertTriangle, Compass } from "lucide-react";

// Shared renderer for a single step/check body: description, CLI, navigation,
// good output and warning signs. Used by Health Check detail pages.
export const StepContent = ({ step }) => (
  <div>
    <p className="text-sm text-zinc-400 leading-relaxed mb-4">{step.description}</p>

    {step.cli_commands?.length > 0 && (
      <div className="mb-4">
        <div className="text-[11px] uppercase tracking-widest text-zinc-500 font-semibold mb-2">CLI Commands</div>
        <CliBlock commands={step.cli_commands} testId={`cli-${step.id}`} />
      </div>
    )}

    {step.navigation?.length > 0 && (
      <div className="mb-4">
        <div className="text-[11px] uppercase tracking-widest text-zinc-500 font-semibold mb-2">CUCM / RTMT Navigation</div>
        <div className="space-y-2">
          {step.navigation.map((nav, i) => (
            <div key={i} className="rounded-md border border-zinc-800 bg-zinc-950 p-3">
              <div className="flex items-start gap-2">
                <Compass className="h-4 w-4 text-blue-400 mt-0.5 shrink-0" />
                <div>
                  <div className="text-[10px] uppercase tracking-wider text-blue-400 font-semibold">{nav.system}</div>
                  <div className="font-mono text-[13px] text-zinc-200 mt-1">{nav.path}</div>
                  {nav.note && <div className="text-xs text-zinc-500 mt-1">{nav.note}</div>}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    )}

    {step.good_output && (
      <div className="rounded-md bg-zinc-950 border border-zinc-800 border-l-4 border-l-emerald-500 p-3 mb-3">
        <div className="flex items-center gap-2 text-emerald-400 text-[11px] uppercase tracking-wider font-semibold">
          <CheckCircle2 className="h-4 w-4" /> Good / Healthy Output
        </div>
        <p className="text-sm text-zinc-300 mt-1.5">{step.good_output}</p>
      </div>
    )}

    {step.bad_signs && (
      <div className="rounded-md bg-zinc-950 border border-zinc-800 border-l-4 border-l-red-500 p-3">
        <div className="flex items-center gap-2 text-red-400 text-[11px] uppercase tracking-wider font-semibold">
          <AlertTriangle className="h-4 w-4" /> Warning Signs
        </div>
        <p className="text-sm text-zinc-300 mt-1.5">{step.bad_signs}</p>
      </div>
    )}
  </div>
);
